<!--DialogBottom-->
<template>
  <v-container fluid class="pa-0" id="gradientbackground">
    <v-row no-gutters>
      <v-col cols="0" :class="isPhoneBool ? 'pa-2' : 'pa-2 pr-0'" class="d-flex justify-space-between">
        <slot name="buttons">
          <v-btn outlined @click="close()">{{ $t('servicesystem.common_objects.commonterms.close') }}</v-btn>
        </slot>
      </v-col>
      <v-col cols="auto" class="d-flex flex-column align-end">
        <v-spacer></v-spacer>
        <v-card v-if="!isPhoneBool" width="32" height="32" flat link
          style="clip-path: polygon(100% 1%, 0% 100%, 100% 100%);" color="transparent">
          <v-icon @mousedown="setDrag" @mouseup="dragging = false" size="24">
            mdi-resize-bottom-right
          </v-icon>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "DialogBottom",
  props: [],
  data() {
    return {
      dragging: false,
      relativePositionX: null,
    };
  },
  beforeDestroy() {
    document.removeEventListener("mousemove", this.mouseEvent);
  },
  mounted() {
    document.addEventListener("mousemove", this.mouseEvent);
  },
  methods: {
    setDrag(e) {
      this.relativePositionX = e.clientX;
      this.dragging = true;
    },
    mouseEvent(e) {
      if (this.dragging) {
        if (e.buttons != 1) {
          this.dragging = false;
          return;
        }
        let m = `x: ${-(this.relativePositionX - e.clientX)} | y: ${e.clientY}`;
        this.$emit("resize", -(this.relativePositionX - e.clientX), e.clientY);
        this.relativePositionX = e.clientX;
        console.log(m);
      }
    },
    press(x) {
      if (x.buttons == 1) {
        this.$emit("resize", x.offsetX, x.offsetY);
        //console.log(x, x.offsetX);
      }
    },
    close() {
      this.$store.state.triggerevents.previewCloseTrigger++;
      this.$emit("Close");
    },
  },
};
</script>

<style lang="scss">
.v-btn--outlined {
  background-color: rgb(255, 255, 255) !important;
}
</style>